<template>
  <div class="animated fadeIn faster">
    <h2
      v-if="!isNovanetScores"
      class="siimple--text-center siimple-h2 siimple--mb-5"
    >
      🏅 Highscore 🏅
    </h2>
    <h2
      v-if="isNovanetScores"
      class="siimple--text-center siimple-h2 siimple--mb-5"
    >
      🏅 Novanet Highscore 🏅
    </h2>
    <p class="siimple--text-center siimple-p">
      Konkurransen er avsluttet og highscore-listen låst
    </p>
    <spinner v-if="isLoading" />
    <div v-if="!isLoading" class="siimple-table">
      <div class="siimple-table-header">
        <div class="siimple-table-row">
          <div class="siimple-table-cell mobile-only">#</div>
          <div class="siimple-table-cell desktop-only">Plassering</div>
          <div class="siimple-table-cell">Brukernavn</div>
          <div class="siimple-table-cell siimple--text-right">
            Antall poeng
          </div>
        </div>
      </div>
      <div class="siimple-table-body">
        <div
          v-for="(highscore, index) in highscores"
          :key="index"
          class="siimple-table-row"
        >
          <div class="siimple-table-cell">{{ highscore.rank }}</div>
          <div class="siimple-table-cell">{{ highscore.name }}</div>
          <div
            v-if="highscore.points < 100"
            class="siimple-table-cell siimple--text-right"
          >
            {{ highscore.points }}
          </div>
          <div
            v-if="highscore.points >= 100"
            class="siimple-table-cell siimple--text-right siimple--text-bold"
          >
            {{ highscore.points }} 👏
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/utils/http-common';
import Spinner from '@/components/Spinner';

export default {
  name: 'HighScores',
  components: {
    Spinner
  },
  props: {
    isNovanetScores: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      highscores: [],
      isLoading: true
    };
  },
  mounted() {
    const url = this.isNovanetScores ? 'highscore/novanet' : 'highscore';
    HTTP.get(url)
      .then(response => {
        this.highscores = response.data;
        this.isLoading = false;
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error(e);
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
@media (max-width: 480px) {
  .siimple-table-cell.mobile-only {
    display: table-cell;
  }
  .siimple-table-cell.desktop-only {
    display: none;
  }
  /* Make sure all input fields are at least 16px on mobile due to ios autozoom feature */
  .siimple-input {
    font-size: 16px;
  }
}
@media (min-width: 481px) {
  .siimple-table-cell.mobile-only {
    display: none;
  }
  .siimple-table-cell.desktop-only {
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HighScores.vue